import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { App } from "./App";

// MSAL v5 silent (hidden iframe) and popup flows no longer poll the child frame's URL -- the page
// at redirectUri must hand the auth response back to the main frame via the redirect bridge, or
// acquireTokenSilent rejects with `timed_out` (redirect_bridge_timeout). Our redirectUri is the
// app origin itself, so when loaded in that role, broadcast the response and skip rendering.
const isAuthResponseFrame =
  (window.parent !== window || Boolean(window.opener)) &&
  /[?#&](code|error|state)=/.test(window.location.hash + window.location.search);

if (isAuthResponseFrame) {
  import("@azure/msal-browser/redirect-bridge")
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch((err) => console.error("[MSAL] redirect bridge failed", err));
} else {
  const root = document.getElementById("root")!;
  createRoot(root).render(
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  );
}
